/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GeneratedOfferResponse } from '../models';
// @ts-ignore
import type { GetBGVRequestsResponse } from '../models';
// @ts-ignore
import type { OfferResponseBody } from '../models';
// @ts-ignore
import type { OnboardingBundleResponse } from '../models';
// @ts-ignore
import type { PlacementDetailResponse } from '../models';
// @ts-ignore
import type { PreviewOfferBody } from '../models';
// @ts-ignore
import type { SendOfferBody } from '../models';
// @ts-ignore
import type { UpdateVerificationBody } from '../models';
/**
 * HiringApiApi - axios parameter creator
 */
export const HiringApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {PreviewOfferBody} previewOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGenerateOfferPreview: async (applicantId: string, jobId: string, orgId: string, previewOfferBody: PreviewOfferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('hiringApiGenerateOfferPreview', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('hiringApiGenerateOfferPreview', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiGenerateOfferPreview', 'orgId', orgId)
            // verify required parameter 'previewOfferBody' is not null or undefined
            assertParamExists('hiringApiGenerateOfferPreview', 'previewOfferBody', previewOfferBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/offer/preview`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewOfferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetApplicantPlacement: async (applicantId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('hiringApiGetApplicantPlacement', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('hiringApiGetApplicantPlacement', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiGetApplicantPlacement', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/placement`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetBackgroundVerifications: async (page?: number, pageSize?: number, searchQuery?: string | null, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/background-verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetOnboardingBundle: async (orgId: string, placementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiGetOnboardingBundle', 'orgId', orgId)
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiGetOnboardingBundle', 'placementId', placementId)
            const localVarPath = `/org/{org_id}/placement/{placement_id}/onboarding-bundle`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetPlacement: async (placementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiGetPlacement', 'placementId', placementId)
            const localVarPath = `/placement/{placement_id}`
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiMarkOnboarded: async (orgId: string, placementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiMarkOnboarded', 'orgId', orgId)
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiMarkOnboarded', 'placementId', placementId)
            const localVarPath = `/org/{org_id}/placement/{placement_id}/onboard`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiResendOffer: async (orgId: string, placementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiResendOffer', 'orgId', orgId)
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiResendOffer', 'placementId', placementId)
            const localVarPath = `/org/{org_id}/placement/{placement_id}/resend-offer`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} placementId 
         * @param {OfferResponseBody} offerResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiRespondOffer: async (placementId: string, offerResponseBody: OfferResponseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiRespondOffer', 'placementId', placementId)
            // verify required parameter 'offerResponseBody' is not null or undefined
            assertParamExists('hiringApiRespondOffer', 'offerResponseBody', offerResponseBody)
            const localVarPath = `/placement/{placement_id}/offer-response`
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {SendOfferBody} sendOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiSendOffer: async (applicantId: string, jobId: string, orgId: string, sendOfferBody: SendOfferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('hiringApiSendOffer', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('hiringApiSendOffer', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiSendOffer', 'orgId', orgId)
            // verify required parameter 'sendOfferBody' is not null or undefined
            assertParamExists('hiringApiSendOffer', 'sendOfferBody', sendOfferBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/offer`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOfferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiStartVerification: async (orgId: string, placementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('hiringApiStartVerification', 'orgId', orgId)
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiStartVerification', 'placementId', placementId)
            const localVarPath = `/org/{org_id}/placement/{placement_id}/start-verification`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} placementId 
         * @param {UpdateVerificationBody} updateVerificationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiUpdateBackgroundVerification: async (placementId: string, updateVerificationBody: UpdateVerificationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('hiringApiUpdateBackgroundVerification', 'placementId', placementId)
            // verify required parameter 'updateVerificationBody' is not null or undefined
            assertParamExists('hiringApiUpdateBackgroundVerification', 'updateVerificationBody', updateVerificationBody)
            const localVarPath = `/admin/background-verifications/{placement_id}`
                .replace('{placement_id}', encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVerificationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HiringApiApi - functional programming interface
 */
export const HiringApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HiringApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {PreviewOfferBody} previewOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiGenerateOfferPreview(applicantId: string, jobId: string, orgId: string, previewOfferBody: PreviewOfferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiGenerateOfferPreview(applicantId, jobId, orgId, previewOfferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiGenerateOfferPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiGetApplicantPlacement(applicantId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiGetApplicantPlacement(applicantId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiGetApplicantPlacement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiGetBackgroundVerifications(page?: number, pageSize?: number, searchQuery?: string | null, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBGVRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiGetBackgroundVerifications(page, pageSize, searchQuery, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiGetBackgroundVerifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiGetOnboardingBundle(orgId: string, placementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingBundleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiGetOnboardingBundle(orgId, placementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiGetOnboardingBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiGetPlacement(placementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiGetPlacement(placementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiGetPlacement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiMarkOnboarded(orgId: string, placementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiMarkOnboarded(orgId, placementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiMarkOnboarded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiResendOffer(orgId: string, placementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiResendOffer(orgId, placementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiResendOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} placementId 
         * @param {OfferResponseBody} offerResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiRespondOffer(placementId: string, offerResponseBody: OfferResponseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiRespondOffer(placementId, offerResponseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiRespondOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {SendOfferBody} sendOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiSendOffer(applicantId: string, jobId: string, orgId: string, sendOfferBody: SendOfferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiSendOffer(applicantId, jobId, orgId, sendOfferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiSendOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} placementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiStartVerification(orgId: string, placementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiStartVerification(orgId, placementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiStartVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} placementId 
         * @param {UpdateVerificationBody} updateVerificationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hiringApiUpdateBackgroundVerification(placementId: string, updateVerificationBody: UpdateVerificationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hiringApiUpdateBackgroundVerification(placementId, updateVerificationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HiringApiApi.hiringApiUpdateBackgroundVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HiringApiApi - factory interface
 */
export const HiringApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HiringApiApiFp(configuration)
    return {
        /**
         * 
         * @param {HiringApiApiHiringApiGenerateOfferPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGenerateOfferPreview(requestParameters: HiringApiApiHiringApiGenerateOfferPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneratedOfferResponse> {
            return localVarFp.hiringApiGenerateOfferPreview(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.previewOfferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiGetApplicantPlacementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetApplicantPlacement(requestParameters: HiringApiApiHiringApiGetApplicantPlacementRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiGetApplicantPlacement(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiGetBackgroundVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetBackgroundVerifications(requestParameters: HiringApiApiHiringApiGetBackgroundVerificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetBGVRequestsResponse> {
            return localVarFp.hiringApiGetBackgroundVerifications(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiGetOnboardingBundleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetOnboardingBundle(requestParameters: HiringApiApiHiringApiGetOnboardingBundleRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingBundleResponse> {
            return localVarFp.hiringApiGetOnboardingBundle(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiGetPlacementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiGetPlacement(requestParameters: HiringApiApiHiringApiGetPlacementRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiGetPlacement(requestParameters.placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiMarkOnboardedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiMarkOnboarded(requestParameters: HiringApiApiHiringApiMarkOnboardedRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiMarkOnboarded(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiResendOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiResendOffer(requestParameters: HiringApiApiHiringApiResendOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiResendOffer(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiRespondOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiRespondOffer(requestParameters: HiringApiApiHiringApiRespondOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiRespondOffer(requestParameters.placementId, requestParameters.offerResponseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiSendOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiSendOffer(requestParameters: HiringApiApiHiringApiSendOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiSendOffer(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.sendOfferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiStartVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiStartVerification(requestParameters: HiringApiApiHiringApiStartVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiStartVerification(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HiringApiApiHiringApiUpdateBackgroundVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hiringApiUpdateBackgroundVerification(requestParameters: HiringApiApiHiringApiUpdateBackgroundVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementDetailResponse> {
            return localVarFp.hiringApiUpdateBackgroundVerification(requestParameters.placementId, requestParameters.updateVerificationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for hiringApiGenerateOfferPreview operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiGenerateOfferPreviewRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly previewOfferBody: PreviewOfferBody
}

/**
 * Request parameters for hiringApiGetApplicantPlacement operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiGetApplicantPlacementRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for hiringApiGetBackgroundVerifications operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiGetBackgroundVerificationsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string | null

    readonly status?: string | null
}

/**
 * Request parameters for hiringApiGetOnboardingBundle operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiGetOnboardingBundleRequest {
    readonly orgId: string

    readonly placementId: string
}

/**
 * Request parameters for hiringApiGetPlacement operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiGetPlacementRequest {
    readonly placementId: string
}

/**
 * Request parameters for hiringApiMarkOnboarded operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiMarkOnboardedRequest {
    readonly orgId: string

    readonly placementId: string
}

/**
 * Request parameters for hiringApiResendOffer operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiResendOfferRequest {
    readonly orgId: string

    readonly placementId: string
}

/**
 * Request parameters for hiringApiRespondOffer operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiRespondOfferRequest {
    readonly placementId: string

    readonly offerResponseBody: OfferResponseBody
}

/**
 * Request parameters for hiringApiSendOffer operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiSendOfferRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly sendOfferBody: SendOfferBody
}

/**
 * Request parameters for hiringApiStartVerification operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiStartVerificationRequest {
    readonly orgId: string

    readonly placementId: string
}

/**
 * Request parameters for hiringApiUpdateBackgroundVerification operation in HiringApiApi.
 */
export interface HiringApiApiHiringApiUpdateBackgroundVerificationRequest {
    readonly placementId: string

    readonly updateVerificationBody: UpdateVerificationBody
}

/**
 * HiringApiApi - object-oriented interface
 */
export class HiringApiApi extends BaseAPI {
    /**
     * 
     * @param {HiringApiApiHiringApiGenerateOfferPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiGenerateOfferPreview(requestParameters: HiringApiApiHiringApiGenerateOfferPreviewRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiGenerateOfferPreview(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.previewOfferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiGetApplicantPlacementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiGetApplicantPlacement(requestParameters: HiringApiApiHiringApiGetApplicantPlacementRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiGetApplicantPlacement(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiGetBackgroundVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiGetBackgroundVerifications(requestParameters: HiringApiApiHiringApiGetBackgroundVerificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiGetBackgroundVerifications(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiGetOnboardingBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiGetOnboardingBundle(requestParameters: HiringApiApiHiringApiGetOnboardingBundleRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiGetOnboardingBundle(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiGetPlacementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiGetPlacement(requestParameters: HiringApiApiHiringApiGetPlacementRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiGetPlacement(requestParameters.placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiMarkOnboardedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiMarkOnboarded(requestParameters: HiringApiApiHiringApiMarkOnboardedRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiMarkOnboarded(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiResendOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiResendOffer(requestParameters: HiringApiApiHiringApiResendOfferRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiResendOffer(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiRespondOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiRespondOffer(requestParameters: HiringApiApiHiringApiRespondOfferRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiRespondOffer(requestParameters.placementId, requestParameters.offerResponseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiSendOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiSendOffer(requestParameters: HiringApiApiHiringApiSendOfferRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiSendOffer(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.sendOfferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiStartVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiStartVerification(requestParameters: HiringApiApiHiringApiStartVerificationRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiStartVerification(requestParameters.orgId, requestParameters.placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HiringApiApiHiringApiUpdateBackgroundVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hiringApiUpdateBackgroundVerification(requestParameters: HiringApiApiHiringApiUpdateBackgroundVerificationRequest, options?: RawAxiosRequestConfig) {
        return HiringApiApiFp(this.configuration).hiringApiUpdateBackgroundVerification(requestParameters.placementId, requestParameters.updateVerificationBody, options).then((request) => request(this.axios, this.basePath));
    }
}

